<template>
  <div class="vip-normal-problem">
    <ul class="p-list">
      <li
        class="p-box"
        v-for="(item,index) in qa"
        :key="index"
      >
        <p class="problem">
          <img
            src="https://cdn.gelonghui.com/static/web/question.png"
            alt
            class="q"
          />
          {{item.title}}
        </p>
        <div class="answer-box">
          <span class="A">A:</span>
          <p class="answer">{{item.answer}}</p>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      qa: [
        {
          title: '会员卡有什么用？',
          answer:
            '该会员卡由格隆汇发布，在参加格隆汇“决战港股”活动或“汇说”会议等线下活动时可作为入场凭证。'
        },
        {
          title: '邀请成功好友对我有什么影响？',
          answer:
            '每邀请成功一位好友，当前会员到期日期将延期10天。最多可以邀请5位好友，会员使用期限最多延长50天。'
        },
        {
          title: '如何领取会员卡？',
          answer:
            '在购买会员卡时，选择”邮寄会员卡“，填写个人配送信息；如不输入收货地址，我们则默认您不需要此卡，不进行配送。'
        },
        {
          title: '会员到期后，还可以继续阅读之前的专享内容吗？',
          answer:
            '会员到期后无法阅读之前阅读过的内容，为了不影响您的使用及继续享有会员服务，可在会员到期前续费。'
        },
        {
          title: '如何邀请好友免费体验黄金会员？',
          answer:
            '在手机端分享至朋友圈或者好友，好友需要在手机端输入手机号码领取，一个账户只可拥有一次体验资格，领取成功后，使用领取的手机账户登录格隆汇APP即可体验会员权益。'
        },
        {
          title: '购买会员服务后可以退款吗？',
          answer:
            '会员服务为虚拟商品，在已开通的付费会员有效期内，如中途主动取消或终止会员资格的，将不会获得该时间段内付费会员费用的退还。在付费会员资格终止/取消后，您将不能再享有格隆汇提供的各项特权服务及增值服务，即不再享有付费会员服务。'
        }
      ]
    };
  }
};
</script>

<style lang="less" scoped>
.vip-normal-problem {
  width: 1200px;
  // height: 500px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 10px 26px 0px rgba(13, 27, 74, 0.12);
  margin: 0 auto;
  .p-list {
    padding: 60px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    .p-box {
      margin-bottom: 59px;
      width: 460px;
      .problem {
        font-size: 18px;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
        line-height: 20px;
        margin-bottom: 19px;
        .q {
          margin-bottom: -4px;
          margin-right: 6px;
          width: 24px;
          height: 24px;
        }
      }
      .answer-box {
        .A {
          font-size: 14px;
          font-weight: 500;
          color: rgba(102, 102, 102, 1);
          line-height: 28px;
          float: left;
        }
        .answer {
          padding-left: 28px;
          font-size: 14px;
          font-weight: 500;
          color: rgba(102, 102, 102, 1);
          line-height: 28px;
        }
      }
    }
  }
}
</style>
